import { useEffect, useState } from 'react';
import { request } from '@/common';
import { Tooltip } from 'antd';
import agentPageStore from '@/pages/agent-home/store';
import userStore from '@/store/user';
import { observer } from 'mobx-react-lite';
import LimitContent from './limit-content';
import { SVGPureIcon } from '@/ui';
import './index.scss';
import client from '@/store/client';
import { HelperCore } from '@/common/dependencies';

const AgentLimit = observer(({pos, isLimitedAgent, className=""}) => {
  const isSe = client.is360se || (HelperCore.isMac() &&  client.isLLQ)
  const agentLimit = agentPageStore.chatLimit;
  // const all_left = (agentLimit.daily_left || 0) + (agentLimit.invite_left || 0)
  const is_member = userStore?.membershipInfo?.is_member
  const membershipUsage = userStore?.membershipUsage?.find((item) => item?.function_id === 'agent_count_limit')
  // const all_left = membershipUsage?.free_remaining + membershipUsage?.gift_remaining + membershipUsage?.count_remaining
  const all_left = membershipUsage?.remaining
  const usage_limit = membershipUsage?.usage_limit || 100;

  if (pos === 'aiagent' && !isLimitedAgent) {
    return null;
  }
  // if (isSe && all_left <= 0) {
  //   return null;
  // }
   return (
    <Tooltip
      align={{ offset: [-10, -16] }}
      color="#16205F"
      // open={true}
      overlayInnerStyle={{
        borderRadius: '14px',
        padding: '18px',
        width: '315px',
        height: isSe ? '152px' : '232px',
        background: 'none',
        backgroundImage:
          isSe ? 'url(//p5.ssl.qhimg.com/t110b9a9301637ff5573a69c101.png)':'url(//p0.ssl.qhimg.com/t110b9a9301bd2d7d8dbbd44a17.png)',
        backgroundSize: '100% 100%',
        position: 'relative',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
      // title={
      //   <div className='text-left'>
      //     <div>限免智能体（超级搜索）规则：</div>
      //     <div>每天可免费使用 {agentLimit.daily_max || 0} 次</div>
      //     <div>您通过邀请好友额外获得了 {agentLimit.invite_total || 0} 次</div>
      //     <div>将优先为您扣除时效性短的次数</div>
      //   </div>
      // }
      title={<LimitContent pos={pos} />}
      overlayClassName="agent-limit-container-tooltip"
    >
      <div
        className={[
          'agent-limit-container',
          'flex items-center gap-6px h-32px px-12px z-10',
          'hover:bg-[rgba(0,0,0,0.06)] bg-[#e9e9e9] rounded-full cursor-pointer font-medium',
          className
        ]}
      >
        <div>
          { isSe ? null : <img
            src={"https://p4.ssl.qhimg.com/t110b9a930133181e3765038a7c.png"}
            alt=""
            srcset=""
            width={20}
            height={20}
          />}
        </div>
        {
          all_left <= 0 && pos !== 'aiso' ? 
          <div>
              <span className="agent-limit-container-num">
                {usage_limit} 纳米/次
              </span>
            </div>
          : <div>
              限免剩余：
              <span className="agent-limit-container-num">
                {all_left}次
              </span>
            </div> 
        }
        <div className="agent-limit-container-question">
          <SVGPureIcon name="viptop" size={16} color={'black'} />
        </div>
      </div>
    </Tooltip>
  );
});

export default AgentLimit;